<template>
  <div class="col-12 h-100">
    <div class="row h-100">
      <div class="mail-actions col-12">
        <div class="row">
          <div class="col-2">
            <button class="btn btn-default">
              <i class="fas fa-bars"></i>
            </button>

            <router-link to="/compose" class="compose-email-btn">
              <button class="btn btn-info btn-sm">
                <i class="far fa-edit text-white"></i> New Message
              </button>
            </router-link>
          </div>
          <div class="col-8">
            <button class="btn btn-default" v-if="selected_threads.length" @click="deleteThreads">
              <i class="far fa-trash-alt"></i> Delete
            </button>

            <button class="btn btn-default">
              <i class="fas fa-undo"></i> Undo
            </button>

            <span class="float-right syncing-indicator" v-if="syncing">
              <button class="btn btn-light" type="button" disabled>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Syncing...
              </button>
            </span>
          </div>

          <div class="col-2 sync-progress" v-if="syncing">
            <div class="progress mt-2 mr-2" style="height: 25px;">
              <div class="progress-bar" role="progressbar" :style="syncProgress" :aria-valuenow="sync_percentage"
                   aria-valuemin="0" aria-valuemax="100">{{ sync_percentage }}%
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-2 mail-folders">
        <div class="col-12 mt-2 text-center">
          <select class="form-control" v-model="selectedEmailAccount" @change="updateActiveAccount">
            <option v-for="account in emailAccounts" :key="account.id" :value="account.id">
              {{ account.email }}
            </option>
          </select>
        </div>

        <div class="folder">
          <router-link to="/0/inbox" class="folder-link">
            <i class="fas fa-inbox"></i>
            Inbox
            <span v-if="unread_inbox_count"
                  class="badge badge-pill float-right unread-count">{{ unread_inbox_count }}</span>
          </router-link>
        </div>

        <div class="folder">
          <router-link to="/0/sent"><i class="far fa-paper-plane"></i> Sent Items</router-link>
        </div>

        <div class="folder">
          <router-link to="/0/trash"><i class="far fa-trash-alt"></i> Deleted</router-link>
        </div>

      </div>

      <div class="col-10 h-100">
        <div class="row h-100">
          <div class="col-4 incoming-emails p-0">

            <div class="emails-header">
              <div class="row">
                <div class="col-1">
                  <i class="far fa-check-circle mt-2 mark-all-threads" @click="selectAllThreads"></i>
                </div>

                <div class="col-11">
                  <div class="input-group mb-3">
                    <input type="text"
                           class="form-control"
                           placeholder="Search"
                           v-on:keyup="onSearchChange"
                           v-on:keyup.enter="triggerSearch"
                           v-on:keyup.esc="clearSearch"
                           v-model="search">

                    <div class="input-group-prepend">
                      <button class="btn btn-outline-primary dropdown-toggle" type="button" data-toggle="dropdown"
                              aria-haspopup="true" aria-expanded="false">
                        Filter
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="incoming-email"
                 v-if="threads.length" v-for="thread in threads" :key="thread"
                 :class="{ active: thread === active_thread_id }">
              <div class="row">
                <div class="col-1">
                  <i v-if="type === 'inbox' || type === 'sent'"
                     class="mark-thread mt-2"
                     @click="toggleThread(thread, $event)"
                     v-bind:class="{
                       'fas fa-check-circle' : isThreadMarked(thread),
                       'far fa-check-circle' : !isThreadMarked(thread)
                       }"
                  >
                  </i>
                </div>

                <div class="col-10" v-bind:class="{'unread-thread' : !isThreadRead(thread)}">
                  <router-link :to="{name : 'inbox_thread', params : {type : type, thread : thread}}">
                    <div class="row">
                      <div class="col-8">
                        <p class="username m-0" v-html="getThreadUser(thread)"></p>
                      </div>
                      <div class="date col-4 p-0 text-right">
                        {{ getFormattedDate(thread) }}
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-9">
                        <p class="email-title m-0" v-html="getThreadSubject(thread)"></p>
                      </div>
                      <div class="col-3 text-right">
                        <i class="mail-envelope"
                           @click="toggleThreadRead(thread, $event)"
                           v-bind:class="{
                             'far fa-envelope-open' : isThreadRead(thread),
                             'far fa-envelope' : !isThreadRead(thread)
                           }"
                        ></i>

                        <span class="thread-message-count">{{ getThreadMessagesCount(thread) }}</span>
                      </div>
                    </div>
                    <p class="email-text m-0" v-html="getThreadSnippet(thread)"></p>
                  </router-link>
                </div>
              </div>
            </div>
          </div>

          <div class="col-8 active-email">
            <div>
              <div class="active-email-header">
                <h5 class="m-0">
                  <b>
                    {{ getActiveThreadSubject() }}
                  </b>
                </h5>
              </div>

              <div class="active-email-body" v-if="active_thread" v-for="message in active_thread">
                <div class="mail-body-header">
                  <div class="row">
                    <div class="col-12 mb-2">
                      <div class="row">
                        <div class="col-1 icon-holder">
                          <img src="https://cdn.iconscout.com/icon/free/png-256/small-diamond-geometric-blue-38006.png"
                               alt=""
                               width="50">
                        </div>
                        <div class="col-11 email-action-container">

                          <div class="row">
                            <div class="col-9">
                              <p class="username m-0" v-html="getMessageUser(message)"></p>
                              <p class="m-0">{{ getFormattedDateAndTime(message.received_at) }}</p>
                              <p class="m-0" v-if="message.type === 'INBOX'">From:
                                {{ getSenderEmail(message.received_from) }}</p>
                              <p class="m-0" v-if="message.type === 'SENT'">To: {{ message.sent_to }}</p>
                              <p class="m-0" v-if="message.cc">CC: {{ message.cc }}</p>
                            </div>

                            <div class="col-3">
                              <a class="text-dark" href="#"
                                 @click="triggerForward(message, $event)">
                                <!--                                <i class="fa fa-share float-right mr-2" title="Forward" aria-hidden="true"></i>-->
                                <img class="float-right  ml-2" src="/images/webmail/forward_icon.png" alt="Forward"
                                     title="Forward" width="22">
                              </a>
                              <a class="text-dark" href="#" @click="triggerReplyToAll(message, $event)">
                                <!--                                <i class="fa fa-reply-all float-right" title="Reply All" aria-hidden="true"></i>-->
                                <img class="float-right ml-2" src="/images/webmail/reply_all_icon.png" alt="Reply All"
                                     title="Reply All" width="22">
                              </a>
                              <a class="text-dark" href="#" @click="triggerReply(message, $event)">
                                <!--                                <i class="fa fa-reply float-right mr-2" title="Reply" aria-hidden="true"></i>-->
                                <img class="float-right" src="/images/webmail/reply_icon.png" alt="Reply" title="Reply"
                                     width="22">
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-12 mb-5" v-if="message.attachments.length">
                      <div class="row">
                        <div class="col-1"></div>
                        <div class="col-11">
                          <div class="attachment-details">
                            Attachments
                          </div>
                          <div class="attachments text-sm-left">
                            <a v-for="attachment in message.attachments"
                               target="_blank"
                               :href="attachment.uri"
                               class="btn btn-link attachment-block attachment-name mb-2"
                               @click="loadAttachment(message, attachment, $event)"
                               v-if="attachment.type === 'attachment'">
                              <img class="attachment-icon" v-bind:src="getAttachmentIcon(attachment.filename)" alt="">
                              {{ attachment.filename }}<br>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-1">
                    </div>

                    <div class="col-10 parsed-email"
                         v-html="message.message.replace(/(<style[\w\W]+style>)/g, '').replace(/class=/g, '')">
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="active_thread && show_compose" style="height: 30px;">
                <button class="btn btn-primary apply-btn-color btn-sm" @click="triggerSendEmail">Send</button>
              </div>
              <compose-webmail v-if="active_thread && show_compose"
                               :reply-to="reply_to"
                               :send-to="recipients"
                               :reply-body="reply_body"
                               :forward-body="forward_body"
                               ref="reply_form">
              </compose-webmail>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from 'moment';
import {createTag} from "@johmun/vue-tags-input";

export default {
  data() {
    return {
      signature: '',
      footer: '',
      emails: [],
      threads: [],
      type: '',
      active_thread: null,
      active_thread_id: '',
      reply_to: '',
      forward_body: '',
      reply_body: '',
      loadMore: true,
      loading: false,
      take: 15,
      skip: 0,
      show_compose: false,
      compose_mode: '',
      recipients: [],
      selected_threads: [],
      account_id: '',
      unread_inbox_count: 0,
      syncing: 0,
      sync_percentage: 0,
      searching: false,
      search: '',
      emailAccounts: [],
      selectedEmailAccount: '',
    };
  },

  computed: {
    syncProgress() {
      return {
        'width': this.sync_percentage + '%',
      }
    }
  },
  methods: {

    onSearchChange(e) {
      this.searching = this.search.length;
    },

    triggerSearch(e) {
      if (!this.search.length) {
        return;
      }
      this.skip = 0;
      this.loadMore = true;
      this.threads = [];
      this.emails = [];
      this.skip = 0;
      this.searchEmails();
    },

    clearSearch(e) {
      this.searching = false;
      this.search = '';
      this.skip = 0;
      this.loadMore = true;
      this.getEmails(this.type, true);
    },

    searchEmails(clear = false) {
      if (this.search.length) {
        this.loading = true;
        axios.get(`/mail/search/${this.type}/${this.search}`, {
          params: {
            take: this.take,
            skip: this.skip
          }
        })
            .then(res => {
              this.loading = false;
              let emails = res.data;
              let threads = Object.keys(emails);
              this.threads = this.threads.concat(threads);
              this.emails = {...this.emails, ...emails};
              this.skip = this.threads.length;

              if (!threads.length) {
                this.loadMore = false;
              }

              if (this.active_thread_id) {
                this.active_thread = this.emails[this.active_thread_id];
              } else {
                let first_thread = this.threads[0];
                this.active_thread = this.emails[first_thread];
                this.active_thread_id = first_thread;
              }
            });
      }
    },

    triggerSendEmail(e) {
      e.preventDefault();
      $('.send-email-btn').trigger('click');
    },

    loadAttachment(message, attachment, event) {
      event.preventDefault();
      this.active_thread.forEach((thread_message, index) => {
        if (thread_message.id === message.id) {
          let attachments = this.active_thread[index].attachments;

          attachments.forEach((message_attachment, attachment_index) => {
            if (message_attachment.id === attachment.id) {
              let url = this.active_thread[index].attachments[attachment_index].uri;

              if (url) {
                window.open(url, '_blank').focus();
              } else {
                let loading = this.active_thread[index].attachments[attachment_index].loading;
                if (!loading) {

                  this.active_thread[index].attachments[attachment_index].loading = true;

                  $.ajax({
                    type: 'GET',
                    url: '/mail/attachment/load',
                    data: {
                      attachment: attachment.id
                    },
                    success: (url) => {
                      this.active_thread[index].attachments[attachment_index].uri = url;
                      this.active_thread[index].attachments[attachment_index].loading = false;
                      window.open(url, '_blank').focus();
                    }
                  });
                }
              }
            }
          });
        }
      });
    },

    getAttachmentIcon(uri) {
      let ext = uri.split(/[#?]/)[0].split('.').pop().trim();
      let images_extensions = ['png', 'jpeg', 'jpg', 'gif'],
          video_extensions = ['webm', 'mkv', 'flv', 'ogg', 'wmv', 'm4v'],
          word_extensions = ['doc', 'docm', 'docx', 'dot', 'dotx', 'odt'],
          powerpoint_extensions = ['pptx', 'pptm', 'ppt'];

      if (images_extensions.includes(ext)) {
        return '/images/webmail/attachments/photo.png';
      }

      if (video_extensions.includes(ext)) {
        return '/images/webmail/attachments/video.jpg';
      }

      if (word_extensions.includes(ext)) {
        return '/images/webmail/attachments/word.png';
      }

      if (powerpoint_extensions.includes(ext)) {
        return '/images/webmail/attachments/ppt.png';
      }

      if (ext === 'tiff') {
        return '/images/webmail/attachments/tiff.png';
      }

      if (ext === 'pdf') {
        return '/images/webmail/attachments/pdf.png';
      }

      return '/images/webmail/attachments/file.png';

    },

    selectAllThreads(e) {
      let checker = (arr, target) => target.every(v => arr.includes(v));
      let already_checked = checker(this.selected_threads, this.threads);
      if (already_checked) {
        this.selected_threads = [];
      } else {
        this.selected_threads = this.threads;
      }
    },

    triggerReply(message, e) {
      e.preventDefault();
      let signature = '<br><div>' + this.signature + '</div>';
      this.compose_mode = 'reply';
      this.reply_to = message.message_id;
      this.show_compose = true;
      this.reply_body = signature + '<div><blockquote class="gmail_quote" style="margin: 0pt 0pt 0pt 0.8ex; border-left: 1px solid rgb(204, 204, 204); padding-left: 1ex;"><pre>' + message.message + '</pre></blockquote></div>';
      this.$nextTick(() => {
        this.$refs.reply_form.updateRecipients(this.getSender());
        this.$refs.reply_form.updateCCs(this.getCC());
        this.$refs.reply_form.setupReplyEmail(this.reply_body);
        this.$refs.reply_form.setReplyTo(message.message_id);
      });
      $('.active-email').animate({scrollTop: $('.active-email')[0].scrollHeight}, "slow");
    },

    triggerReplyToAll(message, e) {
      e.preventDefault();
      let signature = '<br><div>' + this.signature + '</div>';
      this.compose_mode = 'reply_all';
      this.reply_to = message.message_id;
      this.show_compose = true;
      this.reply_body = signature + '<div><blockquote class="gmail_quote" style="margin: 0pt 0pt 0pt 0.8ex; border-left: 1px solid rgb(204, 204, 204); padding-left: 1ex;"><pre>' + message.message + '</pre></blockquote></div>';
      this.$nextTick(() => {
        this.$refs.reply_form.updateRecipients(this.getSender());
        this.$refs.reply_form.updateCCs(this.getCC());
        this.$refs.reply_form.setupReplyEmail(this.reply_body);
        this.$refs.reply_form.setReplyTo(message.message_id);
      });
      $('.active-email').animate({scrollTop: $('.active-email')[0].scrollHeight}, "slow");
    },

    triggerForward(message, e) {
      let body = '';
      body = '<br>' + this.signature;
      body += '---------- Forwarded message ---------<br>';
      body += 'From: ' + message.received_from + '<br>';
      body += 'Date: ' + message.received_at + '<br>';
      body += 'Subject: ' + message.subject + '<br>';
      body += 'To: ' + message.sent_to + '<br><br><br>';
      body += '<pre>' + message.message.replace(/(<style[\w\W]+style>)/g, '') + '</pre>';

      this.compose_mode = 'forward';
      this.show_compose = true;
      this.reply_to = '';
      this.forward_body = '<br><pre>' + body + '</pre>';
      this.$nextTick(() => {
        this.$refs.reply_form.updateRecipients([]);
        this.$refs.reply_form.setupForwardEmail(body);
        this.$refs.reply_form.setReplyTo('');
        this.$refs.reply_form.setSubject('Fwd: ' + this.getThreadSubject(message.thread_id));
      });
      $('.active-email').animate({scrollTop: $('.active-email')[0].scrollHeight}, "slow");
    },

    getEmails(type, clear = false) {
      this.loading = true;
      axios.get(`/mail/emails/${type}`, {
        params: {
          take: this.take,
          skip: this.skip
        }
      })
          .then(res => {
            this.loading = false;
            let emails = res.data;
            let threads = Object.keys(emails);
            if (clear) {
              this.threads = [];
              this.emails = [];
              this.skip = 0;
            }
            this.threads = this.threads.concat(threads);
            this.emails = {...this.emails, ...emails};
            this.skip = this.threads.length;

            if (!threads.length) {
              this.loadMore = false;
            }

            if (this.active_thread_id) {
              this.active_thread = this.emails[this.active_thread_id];
            } else {
              let first_thread = this.threads[0];
              this.active_thread = this.emails[first_thread];
              this.active_thread_id = first_thread;
            }
          });
    },

    handleMessageScroll() {
      let $container = $('.incoming-emails');
      $container.on('scroll', (e) => {
        let element = event.target;
        let scrolled_height = element.scrollHeight - element.scrollTop - 5;
        if (scrolled_height <= element.clientHeight) {
          if (this.loadMore && !this.loading && !this.searching) {
            this.getEmails(this.type);
          } else if (this.loadMore && !this.loading && this.searching) {
            this.searchEmails();
          }
        }
      });
    },

    getFormattedDateAndTime(date) {
      return moment(date).format('M/D/Y hh:mm a');
    },

    getFormattedDate(thread_id) {
      let emails = this.emails[thread_id];
      let count = emails.length;
      let last_email = emails[0];
      let date = moment.utc(last_email.received_at);
      if (count > 1) {
        for (const el of emails) {
          if (el.type.toLowerCase() === this.type.toLowerCase()) {
            date = moment.utc(el.received_at);
            break;
          }
        }
      }
      return date.isValid() ? date.format('ddd M/D') : '';
    },

    getThreadMessagesCount(thread) {
      return this.emails[thread].length > 1 ? this.emails[thread].length : "";
    },

    getThreadUser(thread_id) {
      let emails = this.emails[thread_id];
      let count = emails.length;
      let last_email = emails[count - 1],
          first_email = emails[0];

      let user = '';

      if (first_email.type === 'INBOX') {
        if (first_email.received_from.length) {
          user = first_email.received_from;
        }
      } else if (first_email.type === 'SENT') {
        if (first_email.sent_to.length) {
          user = first_email.sent_to;
        }
      } else if (first_email.type === 'TRASH') {
        let labels = first_email.labels.length ? JSON.parse(first_email.labels) : [first_email.type];

        if (labels.includes('INBOX')) {
          if (first_email.received_from.length) {
            user = first_email.received_from;
          }
        } else if (labels.includes('TRASH')) {
          if (first_email.sent_to.length) {
            user = first_email.sent_to;
          }
        }
      }
      if (user.length) {
        if (user[0] === '<') {
          user = user.split('<').pop().split('>')[0];
        }
        return user;
      }
      return '(No User)';
    },

    getMessageUser(message) {
      let user = '';

      if (message.type === 'INBOX') {
        if (message.received_from.length) {
          user = message.received_from;
        }
      } else if (message.type === 'SENT') {
        if (message.sent_to.length) {
          user = message.sent_to;
        }
      } else if (message.type === 'TRASH') {
        let labels = message.labels.length ? JSON.parse(message.labels) : [message.type];

        if (labels.includes('INBOX')) {
          if (message.received_from.length) {
            user = message.received_from;
          }
        } else if (labels.includes('TRASH')) {
          if (message.sent_to.length) {
            user = message.sent_to;
          }
        }
      }
      if (user.length) {
        if (user[0] === '<') {
          user = user.split('<').pop().split('>')[0];
        }
        return user;
      }
      return '(No User)';
    },

    getThreadSubject(thread_id) {
      let emails = this.emails[thread_id];
      let count = emails.length;
      let last_email = emails[count - 1];

      if (last_email.subject && last_email.subject.length) {
        return last_email.subject;
      }
      return '(No Subject)';
    },

    getActiveThreadSubject() {
      if (this.active_thread) {
        let count = this.active_thread.length;
        let first_email = this.active_thread[0],
            last_email = this.active_thread[count - 1];
        if (last_email.subject.length) {
          return last_email.subject;
        }
        return '(No Subject)';
      }
      return '';
    },

    getSender() {
      if (this.active_thread) {
        if (this.compose_mode === 'reply') {
          let count = this.active_thread.length;
          let first_email = this.active_thread[0],
              last_email = this.active_thread[count - 1];
          if (last_email.received_from.length) {
            let received_from = last_email.received_from;
            return [received_from.split('<').pop().split('>')[0]]; // returns 'two'
          }
        } else if (this.compose_mode === 'reply_all') {
          let emails = [];
          this.active_thread.forEach(message => {
            if (message.received_from.length) {
              let received_from = message.received_from;
              emails.push(received_from.split('<').pop().split('>')[0]);
            }
          });
          return emails;
        } else if (this.compose_mode === 'forward') {
          return [];
        }
      }
    },

    getCC() {
      if (this.active_thread) {
        if (this.compose_mode === 'reply') {
          let count = this.active_thread.length;
          let first_email = this.active_thread[0],
              last_email = this.active_thread[count - 1];
          if (last_email.cc && last_email.cc.length) {
            let received_from = last_email.cc;
            return [received_from.split('<').pop().split('>')[0]]; // returns 'two'
          }
        } else if (this.compose_mode === 'reply_all') {
          let emails = [];
          this.active_thread.forEach(message => {
            if (message.cc.length) {
              let received_from = message.cc;
              emails.push(received_from.split('<').pop().split('>')[0]);
            }
          });
          return emails;
        } else if (this.compose_mode === 'forward') {
          return [];
        }
      }
      return [];
    },

    getSenderEmail(receiver) {
      return receiver.split('<').pop().split('>')[0];
    },

    getThreadSnippet(thread_id) {
      let emails = this.emails[thread_id];
      let first_email = emails[0];

      if (first_email.snippet.length) {
        return first_email.snippet;
      }
      return '';
    },

    getUnreadCount(type, clear = false) {
      axios.get(`/mail/emails/unread_count`)
          .then(res => {
            this.unread_inbox_count = res.data;
          });
    },

    markThreadAsRead(thread_id) {
      axios.get(`/mail/emails/mark_thread_as_read/${thread_id}`, {
        params: {
          account_id: this.account_id,
        }
      })
          .then(res => {
            this.getUnreadCount();

            let emails = this.emails[thread_id];
            emails.forEach((email, index) => {
              this.emails[thread_id][index].is_read = 1;
            });
          });
    },

    markThreadAsUnRead(thread_id) {
      axios.get(`/mail/emails/mark_thread_as_unread/${thread_id}`, {
        params: {
          account_id: this.account_id,
        }
      })
          .then(res => {
            this.getUnreadCount();

            let emails = this.emails[thread_id];
            emails.forEach((email, index) => {
              this.emails[thread_id][index].is_read = 0;
            });
          });
    },

    isThreadMarked(thread) {
      return this.selected_threads.includes(thread);
    },

    isThreadRead(thread) {
      let emails = this.emails[thread];
      let is_read = true;
      emails.forEach((email, index) => {
        if (!email.is_read) {
          is_read = false;
        }
      });
      return is_read;
    },

    deleteThreads() {
      axios.delete(`/mail/emails`, {
        params: {
          type: this.type,
          threads: this.selected_threads,
          account_id: this.account_id,
        }
      })
          .then(res => {
            if (res.data) {

              this.selected_threads.forEach((selected_thread, index) => {
                this.threads = this.threads.filter(function (thread, index, arr) {
                  return thread !== selected_thread;
                });
              });

              if (this.selected_threads.includes(this.active_thread_id)) {
                this.active_thread = null;
                this.active_thread_id = '';
              }

              this.selected_threads = [];

            }
          });
    },

    toggleThread(thread, e) {
      if (this.selected_threads.includes(thread)) {
        this.selected_threads = this.selected_threads.filter(function (selected_thread, index, arr) {
          return thread !== selected_thread;
        });
      } else {
        this.selected_threads.push(thread);
      }
    },

    toggleThreadRead(thread, e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.isThreadRead(thread)) {
        this.markThreadAsUnRead(thread);
      } else {
        this.markThreadAsRead(thread);
      }
    },

    updateActiveAccount() {
      // Assuming you have an API endpoint to update the active account
      const url = `/user/mail_boxes/active`;

      // Make the HTTP request (using axios or fetch)
      axios.post(url, {
        id: this.selectedEmailAccount
      })
      .then(response => {
        window.location.reload();
      })
      .catch(error => {
        // Handle error
        console.error('Error updating active account:', error);
      });
    }
  },
  mounted: function () {
    let $mount = $('#webmail');
    this.account_id = $mount.attr('data-account-id');
    this.syncing = parseInt($mount.attr('data-account-syncing'));
    this.sync_percentage = parseInt($mount.attr('data-account-sync-percentage'));
    if (this.$route.params.thread !== undefined) {
      this.active_thread_id = this.$route.params.thread;
    }
    this.type = this.$route.params.type;
    this.getEmails(this.$route.params.type);
    this.getUnreadCount();
    this.handleMessageScroll();

    axios.get('/settings/users/signatures')
        .then(res => {
          this.footer = res.data.footer;
          this.signature = res.data.email;
        }).catch((err) => {
      // console.log(err);
    });

    // Axios GET request to fetch email accounts
    axios.get('/user/mail_boxes')
      .then(response => {
        this.emailAccounts = response.data.accounts;
        this.selectedEmailAccount = response.data.active_account;
      })
      .catch(error => {
        console.error('Error fetching email accounts:', error);
      });
  },
  watch: {
    $route(to, from) {
      this.active_thread = null;
      this.active_thread_id = '';
      this.reply_to = '';
      this.reply_body = '';
      this.forward_body = '';

      if (to.params.thread !== undefined) {
        this.active_thread_id = to.params.thread;
        this.markThreadAsRead(this.active_thread_id);
      }

      /**
       * If type of the inbox is changed, then update/reset the skip count and loadMore attributes
       */
      if (to.params.type !== from.params.type) {
        this.type = to.params.type;
        this.skip = 0;
        this.loadMore = true;
        this.getEmails(to.params.type, true);
      } else {

        this.active_thread_id = to.params.thread;
        this.show_compose = false;
        this.compose_mode = '';

        if (this.active_thread_id) {
          this.active_thread = this.emails[this.active_thread_id];
        } else {
          let first_thread = this.threads[0];
          this.active_thread = this.emails[first_thread];
          this.active_thread_id = first_thread;
        }
      }
    }
  }
}
</script>
